import React from 'react'
import {Button} from 'antd'
import {ButtonStyle} from '../../../../style/button'
import {i18n} from '../../../../i18n'
import {Color} from "../../../../style/custom/colors"
import {CheckOutlined, ExclamationCircleOutlined} from "@ant-design/icons"
import {useStores} from '../../../../store'
import {observer} from 'mobx-react-lite'

const MedicationOrderButton: React.FC<MedicationOrderButtonProps> = observer(({onClick}) => {
    const {orderSummaryStore} = useStores()

    const getButtonStyle = () => {
        if (orderSummaryStore.orderSummaryError) {
            return {
                ...ButtonStyle.primary,
                color: Color.warningStrong,
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: Color.warningStrong,
            }
        }
        if (!orderSummaryStore.getOrderSummary?.therapyPlanSuccesfulSubmitted) {
            return {
                ...ButtonStyle.primary,
                backgroundColor: Color.base2,
                color: 'white',
                borderWidth: '1px',
                borderStyle: 'solid',
            }
        }
        return ButtonStyle.primary
    }

    const getButtonText = () => {
        if (orderSummaryStore.orderSummaryError) {
            return i18n.t('therapyTab.actions.orderSummaryError')
        }
        return orderSummaryStore.getOrderSummary?.therapyPlanSuccesfulSubmitted
            ? i18n.t('therapyTab.actions.orderSummarySubmitted')
            : i18n.t('therapyTab.actions.orderSummary')
    }

    const getButtonIcon = () => {
        if (orderSummaryStore.orderSummaryError) {
            return <ExclamationCircleOutlined style={{color: Color.warningStrong}}/>
        }
        if (orderSummaryStore.getOrderSummary?.therapyPlanSuccesfulSubmitted) {
            return <CheckOutlined style={{color: Color.green}}/>
        }
        return undefined
    }

    return (
        <Button
            type={'default'}
            shape={'round'}
            style={getButtonStyle()}
            loading={orderSummaryStore.loadingOrderSummary}
            onClick={onClick}
            disabled={!!orderSummaryStore.orderSummaryError}
            icon={getButtonIcon()}
        >
            {getButtonText()}
        </Button>
    )
})

type MedicationOrderButtonProps = {
    onClick: () => void
}

export default MedicationOrderButton